/* eslint-disable @next/next/next-script-for-ga */
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Layout } from '@/components/common';
import WidgetWrapper from '@/components/widget-wrapper/WidgetWrapper';
import Axios from '@/utils/axios';

export default function Page() {
  const [data, setData] = useState(null);

  const { lang } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await Axios.get('pages/404/', {
        headers: {
          'Accept-Language': lang,
        },
      });
      setData(data);
    };
    fetchData();
  }, [lang]);

  return (
    !!data && (
      <Layout
        navbar={data?.menu}
        footer={data?.footer}
        metadata={data?.metadata}
        breadcrumbs={data?.breadcrumbs}
        appDownload={data?.app_download_widget}
      >
        <Head>
          <title>{data?.metadata?.title || data?.name}</title>
          {data?.metadata?.description && (
            <meta name='description' content={data?.metadata?.description} />
          )}
          <meta
            name='keywords'
            content={
              data?.metadata?.keywords || data?.metadata?.title || 'Bakcell'
            }
          />
        </Head>
        <WidgetWrapper widgets={data?.widgets} />
      </Layout>
    )
  );
}

Page.Layout = null;
